module.exports = __webpack_public_path__ + "static/media/nda.be80eeed.svg";